import _ from 'lodash';
import memoizeOne from 'memoize-one';
import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

const selectDocumentBundles = createSelector(getSystem, ({ documentBundles }) => documentBundles);

export const selectDocumentBundlesValues = createSelector(selectDocumentBundles, documentBundles =>
  Object.values(documentBundles).sort((a, b) =>
    a.documentBundleTypeName.localeCompare(b.documentBundleTypeName),
  ),
);

export const getFilteredDocumentBundles = createSelector(
  getDebouncedSearchValue,
  selectDocumentBundlesValues,
  searchItems(bundle => [bundle.documentBundleTypeName]),
);

export const getGlobalDocumentBundleTypes = createSelector(
  [getFilteredDocumentBundles],
  documentBundles => documentBundles.filter(({ isGlobal }) => isGlobal),
);

export const getLocalDocumentBundleTypes = createSelector(
  [getFilteredDocumentBundles, getGlobalDocumentBundleTypes],
  (documentBundles, globalDocumentBundleTypes) =>
    _.differenceBy(documentBundles, globalDocumentBundleTypes, 'documentBundleTypeId'),
);

const selectDocumentBundleById = memoizeOne(bundleId =>
  createSelector(selectDocumentBundles, documentBundles => documentBundles[bundleId]),
);

export const selectSortedBundleDocumentTypesByBundleId = memoizeOne(bundleId =>
  createSelector(selectDocumentBundleById(bundleId), ({ documentBundleDocumentTypes }) =>
    _.sortBy(Object.values(documentBundleDocumentTypes || {}), 'orderNumber'),
  ),
);

export const selectBundleDocumentTypeIdsByBundleId = memoizeOne(bundleId =>
  createSelector(selectDocumentBundleById(bundleId), ({ documentBundleDocumentTypes }) =>
    Object.keys(documentBundleDocumentTypes || {}),
  ),
);
